<template>
  <v-footer app style="padding: 0">
    <div style="display: flex; width: 100%">
      <span
        style="
          white-space: nowrap;
          padding: 6px 16px;
          display: flex;
          align-items: center;
          font-size: 12px;
          height: var(--footerHeight);
        "
      >&copy; 2024 MetaRPAS co. LTD</span>
      <UploadFooter />
      <!--<span>&copy; 2020 dotman inc.</span>-->
    </div>
    <v-spacer />
    <!-- <span class="ma-0 pa-0 text-left grey--text" style="font-size:6px">
      EPSG:4326&nbsp;
      center: {{ coordinate.view.center }},&nbsp;
      rotation: {{ coordinate.view.rotation }},&nbsp;
      zoom: {{ coordinate.view.zoon }} &nbsp;
      pointer: {{ coordinate.pointer }},&nbsp;
      (3D)&nbsp;
      position: {{ coordinate.camera.position }},&nbsp;
      altitude: {{ coordinate.camera.altitude }},&nbsp;
      distance: {{ coordinate.camera.distance }},&nbsp;
      heading: {{ coordinate.camera.heading }},&nbsp;
      tilt: {{ coordinate.camera.tilt }}
    </span>-->
  </v-footer>
</template>

<script>
import { mapState } from 'vuex';
export default {
  components: {
    UploadFooter: () => import('@/components/uploadFooter/UploadFooter')
  },
  computed: {
    ...mapState({
      coordinate: (state) => state.dashboard.coordinate
    })
  }
};
</script>

<style></style>
